<template>
  <v-form>
    <v-layout wrap>
      <v-flex lg4 md6 class="layout column justify-space-between ma-0">
        <label> Изображение фона для мобильных (320×480px) </label>
        <div class="d-flex align-center ma-0">
          <v-btn
            @click="$refs.bgXS.click()"
            class="primary ml-0 flex-none"
            outline
          >
            Загрузить
          </v-btn>
          <a
            v-if="files.bgXS"
            :href="files.bgXS.path"
            target="_blank"
            class="subtitle-2 font-weight-medium ellipsis text--primary text"
          >
            {{ files.bgXS.name }}
          </a>
          <v-btn
            v-if="files.bgXS"
            @click="fileDelete('bgXS')"
            icon
            class="ma-0 flex-none"
          >
            <icon-close></icon-close>
          </v-btn>
        </div>
        <input
          v-show="false"
          ref="bgXS"
          type="file"
          @change="changeImg('bgXS')"
        />
      </v-flex>
      <v-flex lg4 md6 class="layout column justify-space-between ma-0">
        <label> Изображение фона для компьютеров (1920×1080px) </label>
        <div class="d-flex align-center ma-0">
          <v-btn
            @click="$refs.bgXL.click()"
            class="primary ml-0 flex-none"
            outline
          >
            Загрузить
          </v-btn>
          <a
            v-if="files.bgXL"
            :href="files.bgXL.path"
            target="_blank"
            class="subtitle-2 font-weight-medium ellipsis text--primary text"
          >
            {{ files.bgXL.name }}
          </a>
          <v-btn
            v-if="files.bgXL"
            @click="fileDelete('bgXL')"
            icon
            class="ma-0 flex-none"
          >
            <icon-close></icon-close>
          </v-btn>
        </div>
        <input
          v-show="false"
          ref="bgXL"
          type="file"
          @change="changeImg('bgXL')"
        />
      </v-flex>
      <v-flex lg4 md6 class="layout column justify-space-between ma-0">
        <label>Логотип</label>
        <div class="d-flex align-center ma-0">
          <v-btn
            @click="$refs.logo.click()"
            class="primary ml-0 flex-none"
            outline
          >
            Загрузить
          </v-btn>
          <a
            v-if="files.logo"
            :href="files.logo.path"
            target="_blank"
            class="subtitle-2 font-weight-medium ellipsis text--primary text"
          >
            {{ files.logo.name }}
          </a>
          <v-btn
            v-if="files.logo"
            @click="fileDelete('logo')"
            icon
            class="ma-0 flex-none"
          >
            <icon-close></icon-close>
          </v-btn>
        </div>
        <input
          v-show="false"
          ref="logo"
          type="file"
          @change="changeImg('logo')"
        />
      </v-flex>
    </v-layout>
    <div v-for="(fieldParams, i) in fields" :key="i" class="py-3">
      <div class="font-weight-bold">{{ fieldParams.name }}</div>
      <v-layout v-for="(params, j) in fieldParams.params" :key="j" wrap>
        <v-flex
          v-for="(field, fieldName) in params"
          :key="fieldName"
          xl2
          md3
          xs6
        >
          <label>{{ field.name }}</label>
          <v-layout class="colorpicker-field" align-center ma-0>
            <color-picker
              v-model="field.value"
              :mode="field.transparency ? 'rgb' : 'hex'"
              class="pr-2"
            ></color-picker>
            <div
              v-if="field.value && field.value !== 'transparent'"
              class="pr-1 text-truncate"
            >
              {{ field.value }}
            </div>
            <div
              v-if="!field.value || field.value === 'transparent'"
              class="pr-1"
            >
              нет
            </div>
            <div
              v-if="field.value && field.value !== 'transparent'"
              @click="field.value = 'transparent'"
              class="link"
            >
              <icon-close></icon-close>
            </div>
          </v-layout>
        </v-flex>
      </v-layout>
    </div>

    <v-btn @click="save" class="primary ml-0 mt-4">Сохранить</v-btn>
  </v-form>
</template>

<script>
import IconClose from "../icon/IconClose.vue";
import requestApi from "../../modules/requestApi";
import config from "../../../config.js";
import CyrillicToTranslit from "cyrillic-to-translit-js";

export default {
  name: "ThemeColorSettings",

  components: {
    IconClose,
  },

  props: {
    // все параметры темы
    params: {
      type: Object,
    },
  },

  data: () => ({}),

  computed: {
    fields() {
      return this.params.color.colors;
    },
    files() {
      return this.params.color.files;
    },
  },

  methods: {
    /**
     * Сохранение параметров шаблона
     */
    save() {
      this.$emit("save", { color: { colors: this.fields, files: this.files } });
    },

    /**
     * Отправляет на загрузку, если выбран файл
     */
    changeImg(ref) {
      const oldFile = this.files[ref];
      if (this.$refs[ref].files[0]) {
        if (oldFile) {
          requestApi
            .deleteFile({ file: this.files[ref].path })
            .then(() => this.fileUpload(ref));
        } else {
          this.fileUpload(ref);
        }
      }
    },

    /**
     * Загрузка файла
     */
    fileUpload(ref) {
      this.files[ref] = this.$refs[ref].files[0];

      // загружаем файл на сервер
      if (this.files[ref].size / 1024 / 1024 > 2) {
        this.$store.dispatch("popupInfoOpen", {
          text: "Размер превышает 2 Мб",
          timeout: 5000,
        });
        this.files[ref] = null;
      } else {
        const cyrillicToTranslit = new CyrillicToTranslit();
        // переводит названия загруженного файла из кириллицы в транслит
        let fileName = cyrillicToTranslit.transform(
          this.$refs[ref].files[0].name,
          "_"
        );
        // дополнительный объект blob с данными размера и расширения картинки
        let blob = this.files[ref].slice(
          0,
          this.files[ref].size,
          this.files[ref].type
        );
        // добавляем в новый File предыдущие значения + имя транслитом + тип содержимого нового Blob
        const newFile = new File([blob], fileName, {
          type: this.files[ref].type,
        });

        requestApi.uploadFile({ file: newFile }).then((response) => {
          this.files[ref] = response;
          this.files[ref].path = `${response.path}`;
          this.save();
        });
      }
    },

    /**
     * Удаление файла с сервера
     */
    fileDelete(ref) {
      if (this.params.id) {
        requestApi.deleteFile({ file: this.files[ref].path }).then(() => {
          this.files[ref] = "";
          this.save();
        });
      }
    },
  },
};
</script>
